import axios from 'axios'

import { initializeApp } from 'firebase/app'

import {
  GoogleAuthProvider,
  OAuthProvider,
  createUserWithEmailAndPassword,
  fetchSignInMethodsForEmail,
  getAuth,
  signInWithCredential,
  signInWithEmailAndPassword,
  signInWithPopup,
} from 'firebase/auth'
import { END_POINT_USER, END_POINT_STRIPE } from './index'
import { axiosInstance } from './axiosInstance'
const firebaseConfig = {
  apiKey: 'AIzaSyDJhozwkxlnZGsnsqo2uvk6iGwywehd5a0',
  authDomain: 'orderdesk-3956c.firebaseapp.com',
  projectId: 'orderdesk-3956c',
  storageBucket: 'orderdesk-3956c.firebasestorage.app',
  messagingSenderId: '665793586690',
  appId: '1:665793586690:web:ef3390e0ccf0293defe91b',
  measurementId: 'G-EVR4CXMMJE',
}

export const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)
export function refreshToken() {
  return auth.currentUser ? auth.currentUser.getIdToken(true) : Promise.resolve(null)
}

export async function getUserName(userId) {
  return axios.get(`${END_POINT_USER}/api/customers/localId/${userId}`)
}
import { createFingerprint } from 'utils/fingerprint'

export async function checkIfExistingUser(email) {
  const fingerprint = await createFingerprint()
  // console.log('fingerprint to check', fingerprint)
  return axios
    .post(`${END_POINT_STRIPE}/check-fingerprint`, {
      fingerprint,
      email,
    })
    .then((res) => res.data)
}
export function postSignUpToken(userLoginData) {
  return createUserWithEmailAndPassword(auth, userLoginData.email, userLoginData.password)
    .then(async (res) => {
      // Awaited so the backend profile exists before the post-signup reads. Not retryable (Firebase user
      // already exists), so a failure here must not fail the signup.
      await axios
        .post(
          `${END_POINT_USER}/api/customers`,
          {
            email: userLoginData.email,
            name: userLoginData.username,
            localId: res.user.uid,
          },
          {
            headers: {
              // Overwrite Axios's automatically set Content-Type
              'Content-Type': 'application/json',
            },
          },
        )
        .catch((error) => console.error('Failed to create customer record:', error))

      return res
    })
    .then((res) => {
      return {
        id: res.user.uid,
        user: res.user,
        login: userLoginData.email,
        displayName: userLoginData.username,
        email: userLoginData.email,
        activated: true,
      }
    })
}

export function postLoginToken(userLoginData) {
  const userCredentails = signInWithEmailAndPassword(auth, userLoginData.email, userLoginData.password)
  return userCredentails
}

export function getSignInMethods(email) {
  return fetchSignInMethodsForEmail(auth, email).catch(() => [])
}

export function handleSendEmailVerification(token) {
  return axios.post(`${END_POINT_USER}/api/customers/verify/${token}`)
}

export function getUser(userToken, uid) {
  return axios.request({
    method: 'get',
    url: `${END_POINT_USER}/api/customers/localId/${uid}`,
  })
}

export function googleLogin(response) {
  // const idToken = response.tokenId;
  const credential = GoogleAuthProvider.credential(null, response.access_token)
  return signInWithCredential(auth, credential)
}

export function microsoftLogin() {
  const provider = new OAuthProvider('microsoft.com')
  provider.setCustomParameters({
    prompt: 'select_account',
  })
  return signInWithPopup(auth, provider)
}

export function forgotPassword(email) {
  const json = JSON.stringify({ email: email })
  return axios.post(`${END_POINT_STRIPE}/users/forgot-password`, json, {
    headers: {
      // Overwrite Axios's automatically set Content-Type
      'Content-Type': 'application/json',
    },
  })
}

export function newPassword(password, token) {
  const formData = new URLSearchParams()
  formData.append('password', password)
  formData.append('token', token)

  return axios.post(`${END_POINT_STRIPE}/api/customers/new-password`, formData, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })
}

export function addUserToBrevo(email, name) {
  const options = {
    method: 'POST',
    url: 'https://api.brevo.com/v3/contacts',
    headers: {
      accept: 'application/json',
      'api-key': import.meta.env.VITE_BREVO_API_KEY,
      'content-type': 'application/json',
    },
    data: {
      listIds: [5],
      updateEnabled: false,
      email: email,
    },
  }

  axios(options)
    .then((response) => {})
    .catch((error) => {
      console.error(error)
    })
}
export function saveSignupInfo(data, config) {
  return axiosInstance.post(`${END_POINT_STRIPE}/save-signup-info`, data, config)
}
// Returns the signed-in user's profile (trade + phone number). Uses axiosInstance so the auth token
// is attached automatically. Non-fatal for callers, so never surface it as a global error toast.
export function getUserProfile() {
  return axiosInstance.get(`${END_POINT_STRIPE}/users/profile`, { skipGlobalError: true })
}
export function sendProposalEmail({ to, subject, content, pdfLink }) {
  const json = JSON.stringify({
    to,
    subject,
    content,
    multipart: true,
    html: true,
    pdfLink,
  })

  return axios.post(`${END_POINT_USER}/api/customers/send-email-attachment`, json, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
}
